import { Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectAdvanceFragment = graphql(`
  fragment RuleEngineEffectAdvanceFields on RuleEngineEffectAdvancePayload {
    __typename
    effectKind
    targetTeamId
    fromStepId
    toStepId
    beforeStatus
    afterStatus
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectAdvanceFragment>;
}

export function RuleEngineEffectAdvancePayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectAdvanceFragment, data);
  return (
    <EffectRow
      applied={p.applied}
      appliedColor="green"
      appliedLabel="ADVANCED"
      skipReason={p.skipReason}
    >
      team {p.targetTeamId.slice(0, 8)}: {p.beforeStatus} → {p.afterStatus}
      {" · "}
      <Text span size="xs" c="dimmed">
        {p.fromStepId.slice(0, 8)} → {p.toStepId.slice(0, 8)}
      </Text>
    </EffectRow>
  );
}
